import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { CustomerModel }    from './models/customer';
import { CustomersService } from './customers.service';
import { MessagesService }  from '../messages/messages.service';

@Component({
  selector   : 'wor-send-customer-portal-invitation',
  template: require('./customer.send-portal-invitation.component.html')
})
export class SendCustomerPortalInvitationComponent {
  @BlockUI('customerPortalInvitationBlock') block: NgBlockUI;

  @Input() customer: CustomerModel;

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => CustomersService))
    private customersService: CustomersService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  confirm ( sendAsSms = false ) : void {
    this.block.start();

    this.customersService.confirmPortalInvitation(this.customer, sendAsSms)
      .then(() => {
        this.messagesService.show(this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.INVITATION_SENT'), 'success');

        this.activeModal.close();
      })
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
  }
}
